module.exports = __webpack_public_path__ + "img/Carte-apaym-06.32713fec.png";